/**
 * Controls whether or not we render the perf app for the SEM discover page
 */ export var NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB = 'NEXTJS_PERF_APP_SEM_DISCOVER_PAGE_2025_FEB';
